import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
} from "react";
import { UserData } from "../models";
import { UserContext } from "../App";
import firebase from "firebase/app";
import "firebase/database";

interface UserDataContextValue {
  userData: UserData | undefined;
}

const UserDataContext = createContext<UserDataContextValue | undefined>(
  undefined
);

interface UserDataProviderProps {
  children: ReactNode;
}

export function UserDataProvider({ children }: UserDataProviderProps) {
  const user = useContext(UserContext);
  const [userData, setUserData] = useState<UserData | undefined>(undefined);

  // Load user data from Firebase
  useEffect(() => {
    if (!user?.uid) {
      setUserData(undefined);
      return;
    }

    const userId = user.uid;
    const ref = firebase.database().ref("/users/" + userId);

    ref.on("value", (snapshot) => {
      const data = snapshot.val();
      setUserData(data);
    });

    return () => {
      ref.off();
    };
  }, [user]);

  return (
    <UserDataContext.Provider value={{ userData }}>
      {children}
    </UserDataContext.Provider>
  );
}

export function useUserData() {
  const context = useContext(UserDataContext);
  if (context === undefined) {
    throw new Error("useUserData must be used within a UserDataProvider");
  }
  return context;
}
